<template>
  <app-layout class="mb-5">
    <template #header>
      <AppHead :title="catalogTitle()" />
      <ShopNav 
        :categories="categories"
        categoryRoute="mtd.wholesale.category"
        shopRoute="mtd.wholesale"
        @category="category"
      />

      <WholesaleCart :cart_items="cart_items" :cart_total="cart_total" :account_balance="user['account_balance']"/>

      <flash-messages detail />
    </template>

    <SaleBanner />

    <CategoryBar 
      :categories="categories" 
      categoryRoute="mtd.wholesale.category"/>
      
    <ShopItems 
      :featured="featured"
      :products="products"
      productLink="mtd.wholesale.view"
      :isWholesale="true"
      :cart_items="cart_items"
      :popular="popular"
      :buy_again="buy_again"
      :suggested="suggested"
      :routes="{
        add: 'mtd.cart.add',
        update: 'mtd.cart.updateItem',
        delete: 'mtd.cart.deleteItem',
        category: 'mtd.wholesale.category',
        shop: 'mtd.wholesale'
      }"
    />
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FlashMessages from '@/Shared/FlashMessages'
  import ShopNav from '@/Components/Nav/ShopNav'
  import ShopItems from '@/Components/Shop/ShopItems'
  import WholesaleCart from '@/Components/Shop/WholesaleCart'
  import SaleBanner from '@/Components/Shop/SaleBanner'
  import CategoryBar from '@/Components/Nav/CategoryBar'


  export default {
    data() {
      return {
        categoryName: ''
      }
    },
    components: {
      AppLayout,
      FlashMessages,
      ShopNav,
      ShopItems,
      WholesaleCart,
      SaleBanner,
      CategoryBar
    },
    props: {
      products: Array,
      user: Object,
      cart_items: Array,
      cart_total: Number,
      categories: Array,
      query: String,
      buy_again: Array,
      suggested: Array,
      popular: Array,
      featured: Array,
    },
    methods: {
      category(cat) {
        this.categoryName = cat
      },
      catalogTitle() {
        const manufacturer = this.$page.props.manufacturers.filter(elem => { return elem.value === Number(this.$page.props.manufacturer_id) })
        const manufacturerLabel = manufacturer[0] ? ' - ' + manufacturer[0].label : ''
        return `Wholesale Store ${this.categoryName ? ' - ' + this.categoryName : ''} ${manufacturerLabel}`
      },
    }
}
</script>
